export default __webpack_public_path__ + "static/media/ic_alert.637c8f6a.svg";